import r from"react";import e from"react-indiana-drag-scroll";var t=function(t){var a=t.children;return r.createElement(e,{vertical:!1},r.createElement("table",null,a))};export{t as default};
